import {createDetailResponseSchema} from 'src/feature/bite/domain'
import z from 'zod'

export const ItemSchema = z.object({
  id: z.string().nullable(),
  status: z.number().nullable(),
  usageLimit: z.number(),
  isEditable: z.boolean(),
  isSubscriptionPackage: z.boolean(),
  duration: z.number().nullable(),
  attribute1: z.string().nullable(),
  attribute2: z.string().nullable(),
  attribute3: z.string().nullable(),
  attribute4: z.string().nullable(),
  attribute5: z.string().nullable(),
  attribute6: z.string().nullable(),
  attribute7: z.string().nullable(),
  attribute8: z.string().nullable(),
  genericPaymentLink: z.string().nullable().optional(),
  availableFrom: z.string().nullable(),
  availableUntil: z.string().nullable(),
  barcode: z.string().nullable(),
  blackListedForPoints: z.any().nullable(),
  termsAndConditions: z.string().nullable(),
  categoryID: z.string().nullable(),
  detail: z.string().nullable(),
  discount: z.number().nullable(),
  discountFixAmount: z.number().nullable(),
  discountFixAmountBase: z.number().nullable(),
  displayOrder: z.number().nullable(),
  eligibleForPoints: z.any().nullable(),
  familyID: z.string().nullable(),
  imagesData: z.any().nullable(),
  name: z.string().nullable(),
  lowStockThreshold: z.number().nullable(),
  payWithPoints: z.any().nullable(),
  price: z.number().nullable(),
  priceBase: z.number().nullable(),
  priceWithoutTax: z.number().nullable(),
  priceWithoutTaxBase: z.number().nullable(),
  itemBrandID: z.string().nullable(),
  itemID: z.string().nullable(),
  itemTitle: z.string().nullable(),
  itemTypeID: z.string().nullable(),
  purchaseType: z.number().nullable(),
  ribbon: z.number().nullable(),
  salePrice: z.number().nullable(),
  salePriceBase: z.number().nullable(),
  salesUnitID: z.string().nullable(),
  sku: z.string().nullable(),
  soldIndividually: z.number().nullable(),
  stockQuantity: z.number().nullable(),
  subCategoryID: z.string().nullable().optional(),
  taxRate: z.number().nullable(),
  infoContentData: z.array(z.any()).nullable().optional(),
  taxStatus: z.number().nullable(),
  visibility: z.any().nullable(),
  directSale: z.boolean().nullable(),
  eStore: z.boolean().nullable(),
  paymentLink: z.boolean().nullable(),
})

export const ItemSchemaResponse = createDetailResponseSchema(ItemSchema)

export type Item = z.infer<typeof ItemSchema>
export type ItemResponse = z.infer<typeof ItemSchemaResponse>
